
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

import global from "../../../static/js/global.js";
import loadPage from "../../components/loadingPage";
import $ from "jquery";
import XInput from "vux/src/components/x-input/index";
export default {
components: {
XInput,
PopupPicker,
Group,
XButton,
Flexbox,
FlexboxItem,
Alert,
Confirm,
loadPage,
$,
Datetime
},
data() {
return {
show_1: false,
btnSUM: false,
isAgent: "",
baseIMG: "",
billCode:'',
feeShow:false,
dailogMessage:'',
feeName:'',
};
},
beforeMount() {},
mounted() {
this.int();
this.getUserName();

$(".am_ulist").delegate("li", "click", function() {
$(this).find("button").addClass("am_persfors");
$(this).siblings("li").find("button").removeClass("am_persfors");
});
},
methods: {
/*设置缴费金额*/
setPayMoney(money) {
console.log(money);
$("#moneyJE").val(money);
this.btnSUM = true;
this.int();
},

onInput() {
var moneyJE = $("#moneyJE").val();
if (moneyJE != "") {
this.btnSUM = true;
this.int();
} else if (moneyJE == "") {
this.btnSUM = false;
this.int();
}
},

getUserName() {
let senddata = new Object();
senddata.openId = this.$router.history.current.query.openid;
let tempCode = this.$router.history.current.query.comnCode;
senddata.comnCode = tempCode.split("_")[0];
senddata.feeCode = tempCode.split("_")[1];
let url = global.host + "wechatCharge/index";
this.$http.post(url, senddata).then(
function(res) {
console.log(res);
if (res.status == "200") {
this.isAgent = res.body.result.isAgent;
this.baseIMG = res.body.result.feeFactor;
this.feeName = res.body.result.feeName;
$("#beiZu").val(this.feeName);
} else {
this.feeShow = true;
this.dailogMessage = "网络错误";

}
},
function(err) {
console.log(err);
}
);
},
int() {
if (this.btnSUM == false) {
$("#sumFK").addClass("opC");
} else {
$("#sumFK").removeClass("opC");
}
},

submitBefore() {
if (this.btnSUM == true) {
let sendMoney = new Object();
sendMoney.sumFeeMoney = $("#moneyJE").val();
sendMoney.remark =  $("#beiZu").val();
let tempCode = this.$router.history.current.query.comnCode;
sendMoney.comnCode = tempCode.split("_")[0];
sendMoney.feeCode = tempCode.split("_")[1];
let url = global.host + "wechatCharge/collectTemporary";
this.$http.post(url, sendMoney).then(
function(res) {
console.log(res);
if (res.status == "200") {
this.show_1 = true;

this.billCode = res.body.result;

this.goPay();
} else {
this.feeShow = true;
this.dailogMessage = "网络错误";

}
},
function(err) {
console.log(err);
}
);
}
},

goPay(){
let senddata = new Object();
senddata.phone = '';
let tempCode = this.$router.history.current.query.comnCode;
senddata.comnCode = tempCode.split("_")[0];
senddata.memberNo = '';
senddata.feeCode = tempCode.split("_")[1];
senddata.openid = this.$router.history.current.query.openid;
senddata.tradeAmount =  $("#moneyJE").val();
senddata.tradeNo = this.billCode.billCode;
senddata.tradeName=this.feeName;
senddata.tradeDesc=this.feeName;
let url = global.host + 'wechatCharge/getpayurl'
this.$http.post(url,senddata).then(function(res){
this.show_1 = false;
if(res.body.code == '110'){
window.location.href = res.body.payurl;
}else{
this.feeShow = true;
this.dailogMessage = "网络错误";
}

},function(err){
console.log(err)
})
},
}
};



// WEBPACK FOOTER //
// ./src/components/carRentComponents/zhiF.vue